// 门禁预约-访客申请
<template>
  <div class="RKEAppointmentApply">
    <div class="formBox">
      <p class="title">被访者信息</p>
      <ul class="form">
        <li class="li">
          <label class="left" for="vadr">访问地点</label>
          <div class="right">
            <input
              type="text"
              name="vadr"
              id="vadr"
              placeholder="请输入地点"
              v-model="address"
              disabled
            />
          </div>
        </li>
        <li class="li">
          <label class="left" for="uname">被访者姓名</label>
          <div class="right">
            <input
              type="text"
              name="uname"
              id="uname"
              placeholder="请输入姓名"
              v-model="params.uname"
              @blur="unameBlur"
              :disabled="$route.params.user_id"
            />
          </div>
        </li>
        <li class="li">
          <label class="left" for="vph">被访者电话</label>
          <div class="right">
            <!-- <input type="text" name="vph" id="vph" placeholder="请输入联系电话" v-model="params.vph" @input="vphInput" /> -->
            <input
              type="number"
              name="vph"
              id="vph"
              placeholder="请输入联系电话"
              v-model="params.vph"
              pattern="[0-9]*"
              @input="vphInput"
              @blur="vphBlur"
              :disabled="$route.params.user_id"
            />
          </div>
        </li>
        <li class="li">
          <label class="left" for="start_time">访问开始时间</label>
          <div class="right end" @click="showDatePicker('start')">
            <input
              type="text"
              placeholder="请选择访问开始时间"
              v-model="params.start_time"
              disabled
            />
            <span class="ico ico-right"></span>
          </div>
        </li>
        <li class="li">
          <label class="left" for="end_time">访问结束时间</label>
          <div class="right end" @click="showDatePicker('end')">
            <input
              type="text"
              placeholder="请选择访问结束时间"
              v-model="params.end_time"
              disabled
            />
            <span class="ico ico-right"></span>
          </div>
        </li>
      </ul>
    </div>
    <div class="formBox formBoxCover">
      <div class="cover" v-if="!isOYX" @click="formBoxCoverClick"></div>
      <p class="title">访客信息</p>
      <ul
        class="form vForm"
        v-for="(item, index) in params.visitor"
        :key="index"
      >
        <div class="vNumber" v-show="params.visitor.length != 1">
          <p class="text">访客{{ index + 1 }}</p>
          <span
            class="ico ico-round_close_fill_light"
            @click="deleteVisitor(index)"
          ></span>
        </div>
        <li class="li m">
          <label class="left" for="vphoto">访客照片</label>
          <div
            class="right between"
            @click="activeIndex = index"
            v-if="item.vphoto == ''"
          >
            <input
              type="text"
              name="vphoto"
              id="vphoto"
              placeholder="请提交访客本人照片"
              disabled
            />
            <van-uploader :after-read="afterRead">
              <span class="ico ico-camera"></span>
            </van-uploader>
          </div>
          <div class="right" v-else>
            <van-uploader :after-read="afterRead">
              <img
                id="vphotoImg"
                class="vphoto"
                :src="item.vphoto"
                alt="访客照片"
              />
            </van-uploader>
          </div>
        </li>
        <li class="li">
          <label class="left" for="vname">访客姓名</label>
          <div class="right">
            <input
              type="text"
              name="vname"
              id="vname"
              placeholder="请输入姓名"
              v-model="item.vname"
            />
          </div>
        </li>
        <li class="li">
          <label class="left" for="vcard">证件号码</label>
          <div class="right">
            <input
              type="text"
              name="vcard"
              id="vcard"
              placeholder="请输入身份证号"
              v-model="item.vcard"
              @blur="vcardBlur"
            />
          </div>
        </li>
        <li class="li">
          <label class="left" for="vphone">访客电话</label>
          <div class="right">
            <!-- <input type="text" name="vphone" id="vphone" placeholder="请输入电话" v-model="item.vphone"> -->
            <input
              type="number"
              name="vphone"
              id="vphone"
              placeholder="请输入电话"
              pattern="[0-9]*"
              v-model="item.vphone"
              @input="vphoneInput"
              @blur="vphoneBlur"
            />
          </div>
        </li>
      </ul>
      <!-- <input id="file" type="file" accept="image/*" /> -->
      <div class="btn-add" @click="addVisitor">
        <span class="ico ico-add1"></span>
        <span class="text">添加访客</span>
      </div>
    </div>

    <div class="bottom">
      <span class="btn" @click="reset">重置</span>
      <span class="btn" @click="submit">提交</span>
    </div>

    <!-- 时间选择 -->
    <van-popup
      class="date-popup"
      position="bottom"
      :close-on-click-overlay="false"
      v-model="showDateSelect"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="showDateSelect = false"
        @confirm="confirmDate"
        :filter="filter"
      />
    </van-popup>

    <van-popup class="imgDio" v-model="show" :close-on-click-overlay="false">
      <div class="imgDio_content">
        <!-- <img id="initImg" class="hide" style="" src="/static/images/dkb/Access/2.jpg" alt="" @load="drawInitImg($event)"> -->
        <img
          id="initImg"
          class="hide"
          style=""
          :src="initImgSrc"
          alt=""
          @load="drawInitImg($event)"
        />
        <div class="canvasImgBox">
          <img
            id="canvasImgUrl"
            :src="canvasImgUrl"
            class="canvasImgUrl"
            alt=""
          />
        </div>
        <img
          class="icon"
          src="/static/images/icon/icon_rorate.png"
          alt=""
          @click="rotateImg"
        />
        <!-- <p class="ico ico-xuanzhuan" @click="rotateImg"></p> -->
        <div class="btnArea">
          <p class="text" @click="show = false">取消</p>
          <p class="text h" @click="drawInitImg('init')">还原</p>
          <p class="text" @click="confirmImg">完成</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { RKEApi } from "../../../../static/js/phone/phoneApi.js";
import {
  vconfirm,
  vshowSuccess,
  vNotify,
  vNotifyClose,
  vshowLoading,
  vhideLoading
} from "../../../../static/js/phone/utility.js";
import {
  getNowDate,
  showLoading,
  hideLoading,
  st
} from "../../../../static/js/utility/utility.js";
import * as wx from "../../../../static/js/phone/jweixin-1.3.2.js";
import EXIF from "exif-js";

import Vue from "vue";
import lrz from "lrz";
import { DatetimePicker, Popup, Uploader, Dialog } from "vant";
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Uploader);
Vue.use(Dialog);

import axios from "axios";

let vm,
  n = 0,
  vphoneReg = /^1[3|4|5|7|8|9][0-9]\d{8}$/, // 手机号校验规则
  vcardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/; // 身份证号校验规则

export default {
  name: "RKEAppointmentApply",
  data() {
    return {
      show: false,
      initImgSrc: "",
      canvasImgUrl: "",

      resdata: "",
      isMiniprogram: false, // 是否在小程序环境中

      address: "",
      isOYX: false, // 被访者验证是否通过

      // 时间选择器
      showDateSelect: false,
      showDateSelectType: "start",
      currentDate: new Date(),
      minDate: new Date(new Date().setHours(0, 0, 0)),
      activeIndex: 0,
      params: {
        uname: "",
        vph: "",
        //5分钟后
        start_time: getNowDate(new Date().getTime() + 300 * 1000, "full"),
        end_time: "",
        visitor: [
          {
            vphoto: "",
            vname: "",
            vcard: "",
            vphone: ""
          }
        ]
      },

      pohtoArr: []
    };
  },

  components: {
    DatetimePicker,
    Popup,
    Uploader
  },

  created() {
    // console.log('tag', this.$route)
    vm = this;
    vm.judgeIsMini();
  },

  mounted() {
    vm.getAddress();
    // console.log('navigator', navigator)
  },

  computed: {
    // maxDate() {
    //   return new Date(new Date(this.params.start_time).setHours(23, 59, 59));
    // }
  },

  methods: {
    // 判断所处环境是否在小程序中
    judgeIsMini() {
      wx.miniProgram.getEnv(function(res) {
        vm.isMiniprogram = res.miniprogram;
      });
    },

    // 获取地址
    async getAddress() {
      let data = vm.$route.params;
      showLoading("获取信息中");
      let res = await RKEApi.getAddress(data);
      hideLoading();
      if (res.meta.code == 200) {
        vm.address = res.data.address;
        if (data.id || data.user_id) {
          vm.params.uname = res.data.user_name;
          vm.params.vph = res.data.phone_no;
          vm.getVisitor();
        }
        if (data.id) {
          vm.params.start_time = res.data.start_time;
          vm.params.end_time = res.data.end_time;
          vm.params.visitor = res.data.appiont;
        }
      } else {
        vNotify(res.meta.message, 0);
      }
    },

    /* 监听被访者姓名输入 */
    unameBlur(e) {
      // console.log('tag', e.target.value != '' && vm.params.vph.length==11)
      if (e.target.value != "" && vm.params.vph.length == 11) {
        vm.getVisitor();
      }
    },

    /* 监听被访者手机号输入 */
    vphInput(e) {
      // console.log('e', e.target.value)
      // 限制只能输入数字
      e.target.value = e.target.value.replace(/[^0-9.]+/, "");
      if (e.target.value.length > 11) {
        e.target.value = e.target.value.slice(0, 11);
      }
      if (e.target.value.length == 11 && vm.params.uname != "") {
        vNotifyClose();
        vm.getVisitor();
      }
    },

    vphBlur(e) {
      // if (e.target.value.length<11){vNotify('被访者电话格式不正确', 0)}
      console.log(
        "vphoneReg.test(e.target.value)",
        vphoneReg.test(e.target.value)
      );
      if (!vphoneReg.test(e.target.value)) {
        vNotify("被访者电话格式不正确", 0);
      }
      // console.log('vm.params', vm.params)
    },

    // 查询被访者信息是否正确
    async getVisitor() {
      let data = vm.$route.params;
      data.vname = vm.params.uname;
      data.vph = vm.params.vph;

      let res = await RKEApi.getVisitor(data);
      vm.isOYX = res.meta.code == 200 ? true : false;
      if (res.meta.code == 200) {
        vNotifyClose();
      } else {
        vNotify(res.meta.message, 0);
      }
    },

    // 显示时间选择器
    showDatePicker(type) {
      if (type == "end" && vm.params.start_time == "") {
        vNotify("请先选择授权开始时间");
        return;
      }

      vm.showDateSelectType = type;

      let startTimeDate = new Date(
        Date.parse(vm.params.start_time.replace(/-/g, "/"))
      );
      vm.minDate = type == "start" ? new Date() : startTimeDate;
      let currentDate;
      if (type == "start") {
        let date = new Date();
        let year = date.getFullYear();
        vm.maxDate = new Date(year + 1, 11, 31, 23, 59, 59);
        // 显示时间是否大于当前时间
        let isGtNow =
          new Date(vm.params.start_time).getTime() > new Date().getTime();

        currentDate = startTimeDate;
      } else if (type == "end") {
        currentDate = console.log(vm.params.end_time.replace(/-/g, "/"));
        console.log(Date.parse(vm.params.end_time.replace(/-/g, "/")));
        console.log(
          new Date(Date.parse(vm.params.end_time.replace(/-/g, "/")))
        );
        vm.params.end_time === ""
          ? startTimeDate
          : new Date(Date.parse(vm.params.end_time.replace(/-/g, "/")));

        let startTime = vm.params.start_time;
        vm.minDate = new Date(new Date(startTime).getTime() + 5 * 60 * 1000);
        vm.maxDate = new Date(new Date(startTime).setHours(23, 59, 59));
      }
      console.log("currentDate", currentDate);
      vm.currentDate = currentDate;
      vm.showDateSelect = true;
    },

    // 确认时间
    confirmDate(value) {
      // console.log('value', getNowDate(value, 'full'))
      if (vm.showDateSelectType == "start") {
        vm.params.start_time = getNowDate(value, "full");
      }
      if (vm.showDateSelectType == "end") {
        vm.params.end_time = getNowDate(value, "full");
      }
      vm.showDateSelect = false;
      // console.log('vm.showDateSelectType', vm.showDateSelectType)
      // console.log('时间', vm.params.start_time, vm.params.end_time)
    },

    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      } else if (type === "hour") {
        return `${value}时`;
      } else if (type === "minute") {
        return `${value}分`;
      }
      return value;
    },

    // 点击访客部分遮层
    formBoxCoverClick() {
      vNotify("请先验证通过被访者信息", 0);
    },

    // 访客手机号检验
    vphoneInput(e) {
      // 限制只能输入数字
      e.target.value = e.target.value.replace(/[^0-9.]+/, "");
      if (e.target.value.length > 11) {
        e.target.value = e.target.value.slice(0, 11);
      }
    },

    vphoneBlur(e) {
      if (!vphoneReg.test(e.target.value)) {
        vNotify("访客电话格式不正确", 0);
      } else {
        vNotifyClose();
      }
    },

    // 访客身份证号验证
    vcardBlur(e) {
      if (!vcardReg.test(e.target.value)) {
        vNotify("访客身份证号格式不正确", 0);
      } else {
        vNotifyClose();
      }
    },

    // 点击添加访客
    addVisitor() {
      vm.params.visitor.push({
        vphoto: "",
        vname: "",
        vcard: "",
        vphone: ""
      });
    },

    // 点击删除访客
    deleteVisitor(index) {
      vm.params.visitor.splice(index, 1);
    },

    // 上传接口时：需将base64URL转换为file
    dataURLtoFile(dataurl, filename) {
      // console.log('dataurl', dataurl)
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    // 点击添加/修改照片
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log("图片初始信息", file);

      lrz(file.file, { width: 800 })
        .then(function(rst) {
          // 处理成功会执行
          console.log("处理成功rst", rst);
          // console.log('处理成功rst.file', rst.file)
          vm.initImgSrc = rst.base64;
          vm.show = true;
          // vm.uploadImage(rst)
        })
        .catch(function(err) {
          // 处理失败会执行
          vNotify("图片上传失败，请重新选择");
        })
        .always(function() {
          // 不管是成功失败，都会执行
        });
      console.log("activeIndex", vm.activeIndex);
    },

    //初始加载待上传图片/还原照片
    drawInitImg(e) {
      // console.log('e', e)
      vshowLoading("处理中...");
      let canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      let imgObj = e === "init" ? document.getElementById("initImg") : e.target;
      let image = null;
      // console.log('imgObj', imgObj)
      canvas.width = imgObj.width;
      canvas.height = imgObj.height;
      ctx.drawImage(imgObj, 0, 0, imgObj.width, imgObj.height);

      console.log("imgObj宽高", imgObj.width, imgObj.height);
      console.log("canvas宽高", canvas.width, canvas.height);

      image = canvas.toDataURL("image/jpg");
      vm.canvasImgUrl = image;
      vhideLoading();
    },

    // canvas旋转图片
    rotateImg() {
      n = n + 1;
      // console.log('n', n)
      vshowLoading("处理中...");
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var imgObj = document.getElementById("initImg");
      console.log("imgObj宽高", imgObj.width + "*" + imgObj.height);

      switch (n) {
        case 1:
          canvas.width = imgObj.height;
          canvas.height = imgObj.width;
          ctx.rotate((270 * Math.PI) / 180);
          ctx.drawImage(imgObj, -imgObj.width, 0, imgObj.width, imgObj.height);
          break;
        case 2:
          canvas.width = imgObj.width;
          canvas.height = imgObj.height;
          ctx.rotate((180 * Math.PI) / 180);
          ctx.drawImage(
            imgObj,
            -imgObj.width,
            -imgObj.height,
            imgObj.width,
            imgObj.height
          );
          break;
        case 3:
          canvas.width = imgObj.height;
          canvas.height = imgObj.width;
          ctx.rotate((90 * Math.PI) / 180);
          ctx.drawImage(imgObj, 0, -imgObj.height, imgObj.width, imgObj.height);
          break;
        default:
          n = 0;
          canvas.width = imgObj.width;
          canvas.height = imgObj.height;
          ctx.drawImage(imgObj, 0, 0, imgObj.width, imgObj.height);
          break;
      }
      var image = canvas.toDataURL("image/jpg");
      vm.canvasImgUrl = image;
      vhideLoading();
    },

    // 确认图片-并上传
    confirmImg() {
      let formData = new FormData();
      let raw = vm.dataURLtoFile(vm.canvasImgUrl, "face.jpg");
      formData.append("file", raw);
      vm.show = false;
      vm.uploadImage({ formData: formData });
    },

    // 上传图片
    async uploadImage(data) {
      let res = await RKEApi.uploadImage(data.formData);
      console.log("res", res);
      vshowLoading("上传图片中...");
      if (res.meta.code === 200) {
        vshowSuccess("上传图片成功");
        vm.params.visitor[vm.activeIndex].vphoto = res.data;
        // vm.params.visitor[vm.activeIndex].vphoto = data.base64
      } else {
        vNotify("图片上传失败，请重新上传");
      }
    },

    // 重置
    reset() {
      vconfirm("重置将会清除所有信息，确认重置？")
        .then(function() {
          console.log("tag", vm.$route.params.user_id);
          console.log("tag", vm.params);
          vm.params = {
            uname: vm.$route.params.user_id ? vm.params.uname : "",
            vph: vm.$route.params.user_id ? vm.params.vph : "",
            start_time: getNowDate(new Date(), "full"),
            end_time: "",
            visitor: [
              {
                vphoto: "",
                vname: "",
                vcard: "",
                vphone: ""
              }
            ]
          };
        })
        .catch(function() {
          // console.log('已取消', '')
        });
    },

    // 提交预约信息
    submit() {
      // console.log('tag',getNowDate(new Date(), 'null'), new Date(getNowDate(new Date(), 'null')).getTime())
      // console.log('tag',vm.params.start_time,  new Date(vm.params.start_time).getTime())
      // return
      let data = vm.params;
      data.aid = vm.$route.params.aid;
      if (vm.$route.params.id) {
        data.edit_id = vm.$route.params.id;
      }

      if (data.uname == "") {
        vNotify("被访者姓名不能为空");
        return;
      }
      if (data.vph == "") {
        vNotify("被访者电话不能为空");
        return;
      }
      if (data.start_time == "") {
        vNotify("访问开始时间不能为空");
        return;
      } else {
        if (
          new Date(data.start_time).getTime() -
            new Date(getNowDate(new Date(), "null")).getTime() <
          0
        ) {
          vNotify("访问开始时间不能早于当前提交时间");
          return;
        }
        if (
          new Date(data.end_time).getTime() -
            new Date(data.start_time).getTime() <
          0
        ) {
          vNotify("访问结束时间不能早于开始时间");
          return;
        }
      }
      if (data.end_time == "") {
        vNotify("访问结束时间不能为空");
        return;
      }
      // 访客信息验证
      for (let i in data.visitor) {
        let item = data.visitor[i];
        if (item.vphoto == "") {
          vNotify("访客照片不能为空");
          return;
        }
        if (item.vname == "") {
          vNotify("访客姓名不能为空");
          return;
        }
        if (item.vcard == "") {
          vNotify("访客身份证号不能为空");
          return;
        }
        if (item.vphone == "") {
          vNotify("访客手机号不能为空");
          return;
        }
        // 默认第一个访客是发起人
        data.visitor[i].ini_status = i == 0 ? "1" : "0";
      }

      vconfirm("确认提交申请？")
        .then(function() {
          vm.visitorInfo(data);
        })
        .catch(function() {});
    },

    // 提交访客信息
    async visitorInfo(data) {
      console.log("提交信息：：", data);
      showLoading("提交中...");
      let res = await RKEApi.visitorInfo(data);
      hideLoading();
      console.log("res", res);
      if (res.meta.code == 200) {
        vm.successOperation();
      } else {
        vNotify(res.meta.message);
      }
    },

    // 提交成功分场景操作（小程序端和网页端）
    successOperation() {
      console.log("vm.isMiniprogram", vm.isMiniprogram);
      if (vm.isMiniprogram) {
        // 若是小程序分享
        if (vm.$route.path.indexOf("appletShare") != -1) {
          vm.$router.push({ path: "/PhonePage/AppointmentInform/Apply" });
        } else {
          vshowSuccess("提交成功");
          setTimeout(() => {
            wx.miniProgram.navigateBack({ delta: 1 });
          }, 1000);
        }
      } else {
        vm.$router.push({ path: "/PhonePage/AppointmentInform/Apply" });
      }
    },

    filter(type, options) {
      if (type === "minute") {
        return options.filter(option => option % 5 === 0);
      }
      if (type === "day") {
      }

      return options;
    }
  },

  watch: {}
};
</script>

<style lang="scss">
.van-toast {
  z-index: 99999;
}
.imgDio {
  .imgDio_content {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon {
      width: 0.35rem;
      height: 0.38rem;
      position: absolute;
      left: 0.5rem;
      bottom: 2rem;
    }
    .btnArea {
      width: 100%;
      height: 1.2rem;
      line-height: 1.2rem;
      font-size: 0.24rem;
      color: #ffffff;
      box-sizing: border-box;
      border-top: 1px solid #0e0e0e;
      display: flex;
      justify-content: space-between;
      position: absolute;
      left: 0;
      bottom: 0;
      .text {
        padding: 0 0.3rem;
        &.h {
          color: #474747;
        }
      }
    }
  }
  .canvasImgBox {
    width: 80%;
    margin: 0 auto 2.38rem;
    .canvasImgUrl {
      width: 100%;
    }
  }
}
.van-notify {
  line-height: 0.56rem;
  padding: 0;
  font-size: 12px;
}
.RKEAppointmentApply {
  width: 100%;
  min-height: 100vh;
  background-color: #f0f2f2;
  padding-bottom: 0.92rem;
  .formBox {
    .title {
      height: 0.56rem;
      line-height: 0.56rem;
      font-size: 0.2rem;
      color: #888888;
      text-indent: 0.3rem;
    }
    .form {
      padding: 0 0.3rem;
      color: #1d1d26;
      background-color: #ffffff;
      .li {
        height: 0.7rem;
        font-size: 0.22rem;
        box-sizing: border-box;
        border-bottom: solid 1px #f3f3f3;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          width: 1.9rem;
          flex-shrink: 0;
        }
        .right {
          width: 3.8rem;
          display: flex;
          align-items: center;
          .ico {
            color: #2d83f4;
          }
          .ico.ico-right {
            margin-left: 0.3rem;
            font-size: 0.2rem;
          }
          .ico.ico-camera {
            font-size: 0.45rem;
          }
          input {
            width: 100%;
            height: 0.54rem;
            line-height: 0.54rem;
            background-color: #ffffff;
          }
          .vphoto {
            width: 0.7rem;
            height: 0.7rem;
            clip: rect(0px, 0px, 0px, 0px);
          }
        }
        .right.end {
          justify-content: flex-end;
          input {
            text-align: right;
          }
        }
        .right.between {
          justify-content: space-between;
        }
      }
      .li.m {
        height: 1rem;
        padding: 0.15rem 0;
      }
    }
    .form.vForm {
      .vNumber {
        height: 0.7rem;
        font-size: 0.24rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .text {
          color: #ffb400;
        }
        .ico.ico-round_close_fill_light {
          color: #aaaaaa;
          font-size: 0.3rem;
        }
      }
      .li {
        border-bottom: none;
      }
      .li:last-child {
        border-bottom: solid 1px #f3f3f3;
      }
    }
    .btn-add {
      width: 100%;
      height: 0.7rem;
      line-height: 0.7rem;
      text-align: center;
      color: #2d83f4;
      font-size: 0.24rem;
      background-color: #ffffff;
      .ico {
        font-size: 0.24rem;
      }
    }
  }
  .formBox.formBoxCover {
    position: relative;
    .cover {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 5;
    }
  }
  .placeholder {
    color: #ababab;
  }
  ::-webkit-input-placeholder {
    color: #ababab;
  }
  ::-moz-placeholder {
    color: #ababab;
  }
  :-ms-input-placeholder {
    color: #ababab;
  }
  .bottom {
    width: 100%;
    height: 0.7rem;
    text-align: center;
    font-size: 0.3rem;
    color: #ffffff;
    background-color: #2d83f4;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    .btn {
      flex: 1;
      opacity: 0.6;
    }
  }
  .bottom:before {
    display: block;
    content: "";
    width: 1px;
    height: 0.6rem;
    background-color: #57bcee;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PhonePage/RKEAppointment/AppointmentApply.vue